module.exports = __webpack_public_path__ + "assets/img/fbm.1248b5c7.png";